import React, { useState, useEffect } from 'react'
import { Tooltip } from "primereact/tooltip";

const parseDate = (dateString) => {
  const [day, month, yearAndTime] = dateString.split('.')
  const [year, time] = yearAndTime.split(' ')
  const [hours, minutes] = time.split(':')
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes), 0)
}
const isSaturday = (date) => date.getDay() === 6
const isSunday = (date) => date.getDay() === 0

const getNextWorkingDayStart = (date) => {
  const nextDay = new Date(date)
  nextDay.setDate(nextDay.getDate() + 1)
  nextDay.setHours(10, 0, 0, 0)
  if (isSunday(nextDay)) {
    nextDay.setDate(nextDay.getDate() + 1)
  }
  return nextDay
}

const calculateTimeLeft = (startTime, duration) => {
  let remainingDuration = duration
  let currentTime = startTime

  while (remainingDuration > 0) {
    const startOfDay = new Date(currentTime).setHours(10, 0, 0, 0)
    const endOfDay = isSaturday(currentTime)
      ? new Date(currentTime).setHours(18, 0, 0, 0)
      : new Date(currentTime).setHours(19, 0, 0, 0)

    if (currentTime.getTime() < startOfDay) {
      currentTime = new Date(startOfDay) // Move to the start of the working day
    }

    if (currentTime.getTime() >= startOfDay && currentTime.getTime() < endOfDay) {
      const workingTimeLeftToday = endOfDay - currentTime.getTime()
      if (workingTimeLeftToday >= remainingDuration) {
        return currentTime.getTime() + remainingDuration
      } else {
        remainingDuration -= workingTimeLeftToday
        currentTime = getNextWorkingDayStart(currentTime) // Move to next working day
      }
    } else {
      currentTime = getNextWorkingDayStart(currentTime) // Move to next working day
    }
  }

  return currentTime.getTime()
}

const DueInTimer = ({ createdAt, materialId }) => {
  const createdAtDate = parseDate(createdAt)
    // Check if the createdAt is on Sunday
    const adjustedStartTime = isSunday(createdAtDate) ? getNextWorkingDayStart(createdAtDate): createdAtDate

  const [timeLeft, setTimeLeft] = useState(0)

  useEffect(() => {
    const targetTime = calculateTimeLeft(adjustedStartTime, 4 * 60 * 60 * 1000)
    const currentTime = new Date().getTime()
    setTimeLeft(targetTime - currentTime > 0 ? targetTime - currentTime : 0)
  }, [])

  useEffect(() => {
    const timerInterval = setInterval(() => {
      const currentTime = new Date()
      const targetTime = calculateTimeLeft(adjustedStartTime, 4 * 60 * 60 * 1000)
      const timeRemaining = targetTime - currentTime.getTime()
      setTimeLeft(timeRemaining > 0 ? timeRemaining : 0)
    }, 1000)

    return () => clearInterval(timerInterval)
  }, [adjustedStartTime])

  const formatTimeLeft = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return {
      time: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
      color: milliseconds > 3600000 ? 'green' : (milliseconds > 1800000 ? 'orange' : 'red'),
    }
  }

  const formattedTime = formatTimeLeft(timeLeft)

  return (
    <>
      <span className={`custom-tooltip-${materialId}`} style={{ color: formattedTime.color }}>
        <b style={{ fontSize: formattedTime.time === "00:00:00" ? '12px' : '15px' }}>
          {formattedTime.time === "00:00:00" ? "OVERDUE!" : formattedTime.time}
        </b>
      </span>

      {formattedTime.time === "00:00:00" && (
        <Tooltip target={`.custom-tooltip-${materialId}`} position="top" autoHide>
          Deadline Passed: Action needed immediately to avoid further delays.
        </Tooltip>
      )}
    </>
  )

}

export default DueInTimer